export default {
  id: '7afb8d454b',

  render() {
    return function (ctx_1, data_1, root) {
      function isArray(arr) {
        return Array.isArray(arr);
      }

      function isFunction(func) {
        return typeof func === 'function';
      }

      function c(val, ctx) {
        if (typeof val !== "undefined" && val !== null) {
          if (isFunction(val)) {
            return val.call(ctx);
          } else return val;
        } else return "";
      }

      root = root || ctx_1 || {};
      var r = '';
      r += '<div class=page data-name=duidelines><div class=navbar><div class=navbar-bg></div><div class="navbar-inner sliding"><div class=left><a href=# class="link back"><i class="icon icon-back"></i> <span class=if-not-md>Back</span></a></div><div class=title>AHA/ASA Guidelines</div></div></div><div class=page-content><div class=block-header>EXTERNAL LINKS ONLINE ONLY</div><div class="list links-list"><ul><li><a class="link external" href=https://www.ahajournals.org/doi/10.1161/STR.0000000000000211>2019 Ischemic Stroke Update</a></li><li><a class="link external" href=https://www.ahajournals.org/doi/10.1161/str.0000000000000158>2018 Ischemic Stroke</a></li><li><a class="link external" href=https://www.ahajournals.org/doi/10.1161/STR.0000000000000134>2018 Arteriovenous Malformations</a></li><li><a class="link external" href=https://www.ahajournals.org/doi/10.1161/STR.0000000000000069>2015 Intracerebral Hemorrhage</a></li><li><a class="link external" href=https://www.ahajournals.org/doi/10.1161/cir.0000000000000296>2015 Infective Endocarditis</a></li><li><a class="link external" href=https://www.ahajournals.org/doi/10.1161/str.0b013e31820a8364>2011 Cerebral Venous Thrombosis</a></li><li><a class="link external" href=https://www.ahajournals.org/doi/10.1161/strokeaha.108.192218>2009 Transient Ischemic Attack</a></li></ul></div></div></div>';
      return r;
    }(this);
  },

  styleScoped: false
};